<template>
  <div
    v-if="minDollars"
    class="col text-center pb-1"
    style="margin: 0 auto;">
    <div
      v-if="!condense"
      class="my-3">
      <h6>Minimum Order</h6>
    </div>
    <small
      v-else
      style="line-height: 16px;">
      <span class="ms-1">
        Min Order: <strong>{{ numeral(minDollars).format('$0,0.00') }}</strong>
      </span>
    </small>
    <div
      class="progress shadow-sm"
      :class="condense ? 'condense-progress' : 'standard-progress'">
      <div
        class="progress-bar bg-success"
        role="progressbar"
        :style="percentStyle">
        <!-- Inside Text -->
        <strong
          v-if="cartAmount >= minDollars"
          class="animate__animated animate__bounceIn animate__faster">
          <i class="fa fa-check-circle"/>
          Achieved!
        </strong>
        <strong v-else>
          {{ numeral(percent).format('0.0%') }}
        </strong>
      </div>
    </div>
    <div v-if="cartAmount < minDollars && !condense">
      {{numeral(cartAmount).format('$0,0.00')}} / <strong>{{ numeral(minDollars).format('$0,0.00') }}</strong>
    </div>
  </div>
</template>

<script setup>
  import { computed } from 'vue';

  // Initialize
  const props = defineProps(['mfg', 'company', 'cart', 'cartAmount', 'cartVendorMatch', 'dropshipCart', 'condense'])

  /* Computed */

  // Min vendor dollars required for shipment
  const minDollars = computed(()=>{
    const min = _.find(props.mfg.details.vendor_mins, v => v.company == props.company && v.minFunction == 'order')
    return parseFloat(min?.minValue) || null
  })

  // Dollar compar var%
  const percent = computed(()=>{
    if(props.dropshipCart && props.cartVendorMatch){
      const value = (props.cartAmount / minDollars.value)
      return value > 1 ? 1 : value
    }
    return null
  })

  // Cart amount vs Vendor min dollars used to drive progress bar
  const percentStyle = computed(()=>{
    return {
      'width': (percent.value * 100) + '%'
    }
  })
  
</script>

<style scoped>
  .condense-progress{
    width: 100%;
    position: relative;
    margin: 0px 5px;
    height: 20px;
  }
  
  .standard-progress{
    height: 30px;
  }
</style>